import React from 'react';
import { legalInfo } from '../utils/legal';

const TermsOfUse: React.FC = () => {
  const name = legalInfo.tradingName || legalInfo.legalName;
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-left">
      <h1 className="text-3xl font-bold mb-4">Website Terms of Use</h1>
      <p className="text-gray-700 mb-6">Last updated: {new Date().getFullYear()}</p>

      <p className="mb-4">These terms govern your use of this website operated by {name}. By using the site, you agree to these terms.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Acceptable use</h2>
      <p className="mb-4">Do not misuse the site, attempt to disrupt it, or infringe others' rights.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Intellectual property</h2>
      <p className="mb-4">All content is owned by or licensed to us. You may not reproduce without permission.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Liability</h2>
      <p className="mb-4">The site is provided "as is". We do not exclude liability that cannot be excluded under law.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Governing law</h2>
      <p className="mb-4">These terms are governed by the laws of England and Wales.</p>
    </div>
  );
};

export default TermsOfUse;





